module.exports = __webpack_public_path__ + "img/made_in_the_us.6eb99509.svg";